"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _FlyoutCartComponent = _interopRequireDefault(require("../../components/FlyoutCartComponent/FlyoutCartComponent"));
var _Button = _interopRequireDefault(require("../Button/Button"));
var _LunaLink = _interopRequireDefault(require("../LunaLink/LunaLink"));
require("./FlyoutCart.scss");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const ListItems = _ref => {
  let {
    items,
    onRemove,
    onChangeQuantity,
    cartSettings,
    Link
  } = _ref;
  return items?.map(item => /*#__PURE__*/_react.default.createElement(_FlyoutCartComponent.default, _extends({
    key: item.id
  }, item, {
    settings: cartSettings,
    onRemove: onRemove,
    onChangeQuantity: onChangeQuantity,
    Link: Link
  })));
};
const CartList = _ref2 => {
  let {
    cartData,
    cartSettings,
    isCartFlyoutActive,
    setCartFlyoutActive,
    onChangeQuantity,
    onRemove,
    Link
  } = _ref2;
  if (cartData?.lineItems?.length > 0) {
    const {
      productsTitle = "Your items"
    } = cartSettings;
    return /*#__PURE__*/_react.default.createElement("section", {
      className: "ter-cart-flyout__items"
    }, /*#__PURE__*/_react.default.createElement("h3", {
      className: "ter-cart-flyout__items__title"
    }, productsTitle, " (", cartData?.totalLineItemQuantity, ")"), /*#__PURE__*/_react.default.createElement(ListItems, {
      items: cartData?.lineItems,
      cartSettings: cartSettings,
      onRemove: onRemove,
      onChangeQuantity: onChangeQuantity,
      Link: Link
    }));
  } else {
    const {
      emptyCartTitle = "Your cart is empty",
      emptyCartMessage = "There is nothing in your cart. Let's add some products.",
      continueShoppingBtnLabel = "Continue Shopping"
    } = cartSettings;
    const handleClickClose = ev => {
      ev.preventDefault();
      setCartFlyoutActive(!isCartFlyoutActive);
    };
    return /*#__PURE__*/_react.default.createElement("section", {
      className: "ter-cart-flyout__empty"
    }, /*#__PURE__*/_react.default.createElement("h3", {
      className: "ter-cart-flyout__empty__title"
    }, emptyCartTitle), /*#__PURE__*/_react.default.createElement("p", {
      className: "ter-cart-flyout__empty__msg"
    }, emptyCartMessage), /*#__PURE__*/_react.default.createElement(_Button.default, {
      size: "md",
      onClick: handleClickClose,
      className: "ter-button--primary--2 ter-cart-flyout__empty__btn"
    }, continueShoppingBtnLabel));
  }
};
const CheckoutButton = _ref3 => {
  let {
    cartData,
    cartSettings,
    isAuthenticated
  } = _ref3;
  if (cartData?.lineItems?.length > 0) {
    if (isAuthenticated) {
      const {
        checkoutBtnLabel = "Proceed to Checkout",
        checkoutBtnUrl = "https://www.trimble.com"
      } = cartSettings;
      return /*#__PURE__*/_react.default.createElement(_LunaLink.default, {
        to: checkoutBtnUrl,
        internalLink: true,
        className: "ter-button ter-button--primary--1 ter-cart-flyout__footer__buttons__btn"
      }, checkoutBtnLabel);
    } else {
      const {
        signInBtnLabel = "Sign In to Checkout",
        signInBtnMethod = () => void 0
      } = cartSettings;
      return /*#__PURE__*/_react.default.createElement(_Button.default, {
        className: "ter-button--primary--1 ter-cart-flyout__footer__buttons__btn",
        size: "lg",
        onClick: signInBtnMethod
      }, signInBtnLabel);
    }
  }
  return null;
};
var _default = props => {
  const {
    cartData,
    cartSettings,
    isCartFlyoutActive,
    setCartFlyoutActive
  } = props;
  const handleClickClose = ev => {
    ev.preventDefault();
    setCartFlyoutActive(!isCartFlyoutActive);
  };
  const currencyFormatter = new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency: cartData?.totalNet?.currencyCode || 'USD'
  });
  const {
    cartTitle = "My Cart",
    subtotalLabel = "Subtotal",
    productsRelatedTitle = "You may also like",
    addedToCartMessage = "{Product Name} was added to cart",
    viewCartBtnLabel = "View Cart",
    viewCartBtnUrl = "https://www.trimble.com",
    finePrint
  } = cartSettings;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: isCartFlyoutActive ? "ter-cart-flyout__modal ter-cart-flyout__modal--deployed" : "ter-cart-flyout__modal",
    onClick: handleClickClose
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: isCartFlyoutActive ? "ter-cart-flyout ter-cart-flyout--deployed" : "ter-cart-flyout"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-cart-flyout__panel"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-cart-flyout__header"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-cart-flyout__header__title"
  }, /*#__PURE__*/_react.default.createElement("svg", {
    width: "18",
    height: "20",
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.41225 2.02226L2.43322 2.02138L2.44517 2.02089L2.48141 2.01945C2.51294 2.01822 2.5583 2.01651 2.61302 2.01461C2.67187 2.01257 2.741 2.01032 2.81497 2.00821C2.82468 2.07349 2.83352 2.13448 2.84103 2.18702C2.84859 2.23995 2.85473 2.28385 2.85896 2.31436L2.8638 2.34942L2.86537 2.36097L2.86819 2.3818L4.61985 12.1911L4.6441 12.3377C4.6594 12.4297 4.68009 12.5532 4.7015 12.6782C4.72275 12.8023 4.74537 12.9317 4.76436 13.034C4.77368 13.0842 4.78332 13.1344 4.7922 13.1764C4.79639 13.1962 4.8024 13.2237 4.80964 13.2521C4.81306 13.2655 4.81949 13.29 4.8286 13.3188C4.82991 13.3232 4.85989 13.4248 4.92495 13.534C5.09241 13.8151 5.342 13.922 5.38939 13.9423L5.39242 13.9436C5.47521 13.9793 5.54536 13.9963 5.5774 14.0035C5.6464 14.019 5.70574 14.0251 5.7328 14.0277C5.79528 14.0336 5.85925 14.0356 5.90687 14.0365C6.00874 14.0385 6.13136 14.0371 6.24057 14.0349C6.35264 14.0326 6.46281 14.0293 6.54418 14.0265L6.64321 14.0229L6.66091 14.0223L16.1412 14.0223C16.6935 14.0223 17.1412 13.5745 17.1412 13.0223C17.1412 12.47 16.6935 12.0223 16.1412 12.0223L6.62075 12.0223L6.61911 12.0223L6.617 12.0096L6.59238 11.8607L6.59121 11.8536L6.2642 10.0223H15.5732C16.5667 10.0223 17.4097 9.29292 17.5524 8.3097L17.9789 5.373C18.1439 4.23704 17.321 3.19563 16.1776 3.0935L4.84616 2.08126L4.84432 2.07095L4.84001 2.03971C4.83546 2.00689 4.82893 1.96021 4.82092 1.90414C4.80496 1.79241 4.78285 1.64149 4.75864 1.48774C4.73484 1.33662 4.70732 1.17185 4.68043 1.03658C4.66746 0.971365 4.65124 0.895577 4.63224 0.825746C4.6233 0.792932 4.60789 0.739399 4.58494 0.68058C4.57363 0.651575 4.55334 0.602675 4.52228 0.546466C4.5004 0.50688 4.42884 0.379647 4.29004 0.261309C4.14554 0.138102 4.00203 0.0875319 3.95909 0.0726921C3.89693 0.0512149 3.84407 0.0394975 3.81318 0.0333338C3.75038 0.020804 3.69415 0.0149392 3.65995 0.0118731C3.58699 0.00533276 3.50837 0.00264453 3.44071 0.00132012C3.30037 -0.0014273 3.12998 0.000480227 2.97369 0.00368696C2.81472 0.00694864 2.65889 0.0118112 2.54355 0.0158197C2.48567 0.0178312 2.43751 0.0196445 2.40366 0.0209617L2.37094 0.0222601H1.14124C0.588951 0.0222601 0.141235 0.469975 0.141235 1.02226C0.141235 1.57454 0.588951 2.02226 1.14124 2.02226H2.41225ZM5.21054 4.12177L5.90705 8.02226L15.5732 8.02226L15.9997 5.08557L5.21054 4.12177ZM5.14124 18C5.14124 16.8954 6.03667 16 7.14124 16C8.2458 16 9.14124 16.8954 9.14124 18C9.14124 19.1046 8.2458 20 7.14124 20C6.03667 20 5.14124 19.1046 5.14124 18ZM14.1412 16C13.0367 16 12.1412 16.8954 12.1412 18C12.1412 19.1046 13.0367 20 14.1412 20C15.2458 20 16.1412 19.1046 16.1412 18C16.1412 16.8954 15.2458 16 14.1412 16Z",
    fill: "#FFF"
  })), cartTitle), /*#__PURE__*/_react.default.createElement("button", {
    className: "ter-cart-flyout__header__close-btn",
    onClick: handleClickClose
  }, /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M13.3 0.70998C12.91 0.31998 12.28 0.31998 11.89 0.70998L6.99997 5.59998L2.10997 0.70998C1.71997 0.31998 1.08997 0.31998 0.699971 0.70998C0.309971 1.09998 0.309971 1.72998 0.699971 2.11998L5.58997 7.00998L0.699971 11.9C0.309971 12.29 0.309971 12.92 0.699971 13.31C1.08997 13.7 1.71997 13.7 2.10997 13.31L6.99997 8.41998L11.89 13.31C12.28 13.7 12.91 13.7 13.3 13.31C13.69 12.92 13.69 12.29 13.3 11.9L8.40997 7.00998L13.3 2.11998C13.69 1.72998 13.69 1.09998 13.3 0.70998Z",
    fill: "white"
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-cart-flyout__body"
  }, cartData?.itemAdded?.name && /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-cart-flyout__message"
  }, /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z",
    fill: "#349C44"
  })), addedToCartMessage.replace('{Product Name}', cartData?.itemAdded?.name)), /*#__PURE__*/_react.default.createElement(CartList, props), cartData?.relatedItems?.length > 0 && /*#__PURE__*/_react.default.createElement("section", {
    className: "ter-cart-flyout__related-items"
  }, /*#__PURE__*/_react.default.createElement("h3", {
    className: "ter-cart-flyout__related-items__title"
  }, productsRelatedTitle), /*#__PURE__*/_react.default.createElement(ListItems, {
    items: cartData?.relatedItems,
    cartSettings: cartSettings,
    Link: cartData?.Link
  }))), cartData?.lineItems?.length > 0 && /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-cart-flyout__footer"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-cart-flyout__footer__subtotal"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "ter-cart-flyout__footer__subtotal__label"
  }, subtotalLabel), /*#__PURE__*/_react.default.createElement("span", {
    className: "ter-cart-flyout__footer__subtotal__value"
  }, currencyFormatter.format(cartData?.totalNet?.amount), " ", cartData?.totalNet?.currencyCode)), /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-cart-flyout__footer__buttons"
  }, /*#__PURE__*/_react.default.createElement(CheckoutButton, props), /*#__PURE__*/_react.default.createElement(_LunaLink.default, {
    to: viewCartBtnUrl,
    internalLink: true,
    className: "ter-button ter-button--primary--2 ter-cart-flyout__footer__buttons__btn"
  }, viewCartBtnLabel)), finePrint && /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-cart-flyout__footer__footnote",
    dangerouslySetInnerHTML: {
      __html: finePrint
    }
  })))));
};
exports.default = _default;